import { FC, useMemo } from 'react';
import Select from '../select';
import { FormProps } from '../helpers';
import Text from '@/components/text';
import { Stack } from '@mui/material';
import { getTelemetryOptions, TelemetryMap, TelemetryType } from '@/lib/models/telemetry';
import TelemetryIcon from '@/components/telemetry-icon';

interface Props extends FormProps {
  value: string;
  onChange: (value: string) => void;
}

const TelemetryTypeSelect: FC<Props> = (props) => {
  const optionsWithIcons = useMemo(() => {
    return getTelemetryOptions().map((opt) => {
      const model = TelemetryMap.get(opt.value as TelemetryType)!;

      return {
        ...opt,
        label: (
          <Stack direction="row" alignItems="center" gap={1}>
            <TelemetryIcon telemetry={model} size="small" />
            <Text>{opt.label}</Text>
          </Stack>
        ),
      };
    });
  }, []);

  return <Select {...props} options={optionsWithIcons} />;
};

export default TelemetryTypeSelect;
